module.exports = __webpack_public_path__ + "static/img/header-logo.db84682.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/header-logo.jpg
// module id = E0vE
// module chunks = 5